// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"e2d5e6b5","667":"359b097e","689":"97665fd9"}[chunkId] + ".chunk.js";
};